<template>
  <div id="app">
    <topbar v-on:childByValue="childByValue" :tabsArray="tabsArray" v-if="showTopbar"></topbar>
    <keep-alive>
    <component v-bind:is="currentTabComponent" :childTabId="childTabId"></component>
    </keep-alive>
    <div v-show="upBtnShow" class="jo-up-btn" @click="scrTop"></div>
  </div>
</template>

<script>
  import topbar from './components/topbar/topbar.vue'
  import maincontent from './components/maincontent/maincontent.vue'
  import carousel from './components/carousel/Carousel.vue'
  import references from './components/maincontent/body/reference/reference.vue'
  import author from './components/author/author.vue'
  import publish from './components/publish/publish.vue'
  import customTab from './components/customTab/customTab.vue'

  export default {
    name: 'app',
    components: {
      topbar,
      maincontent,
      carousel,
      references,
      author,
      publish,
      customTab
    },
    data() {
      return {
        dialogVisible: false,
        location: window.location.href,
        dialogCopy: false,
        currentTabComponent: this.component,
        upBtnShow: false,
        childTabId: null,
        tabsArray: [
          {
            id: 'maincontent',
            label: '全文',
            labelEn:'Full Text',
            name: 'maincontent'
          },
        ],
      }
    },
    methods: {
      childByValue(tabObj) {
          console.log(this.currentTabComponent )
        $('li.tabs-item span').css('color', '#83898a');
        this.currentTabComponent = tabObj[0];
        this.childTabId = tabObj[1];
        this.GLOBAL.tabId = this.childTabId;

        this.$nextTick(function () {
          if(document.getElementById('app').scrollHeight < window.innerHeight){
            $('#page-foot').css('position','fixed')
          }else $('#page-foot').css('position','relative')

//      设置主题色
          $('.theme-font').css('color', this.ARTICLE.theme);
          $('a').css('color', this.ARTICLE.theme);
          $('li.active span').css('color', this.ARTICLE.theme);
          $('.theme-background').css('background-color', this.ARTICLE.theme);
          $('.theme-border').css('border-color', this.ARTICLE.theme);
        })
      },
      scrTop() {
        $('html,body').animate({scrollTop: '0px'})
      },
      findFigTableInSec(sec) {
        let isFig = false;
        for (var i in sec.data) {
          if (sec.data[i].name == 'sec') {
            isFig = this.findFigTableInSec(sec.data[i])
          }
          if (sec.data[i].name == 'figgroup' | sec.data[i].name == 'fig' | sec.data[i].name == 'table') {
            return true;
          }
          if (isFig){
            return true;
          }
        }
        return isFig;
      },
    },
    created() {
      this.GLOBAL.tabId = 'maincontent';
      let hasFig = false;
      for (var i in this.ARTICLE.body) {
        if(this.ARTICLE.body[i].name == 'fig' |this.ARTICLE.body[i].name == 'figgroup' | this.ARTICLE.body[i].name == 'table'){
          hasFig = true;
        }else if (this.ARTICLE.body[i].name == 'sec') {
          hasFig = this.findFigTableInSec(this.ARTICLE.body[i])
        }
        if (hasFig){
          this.tabsArray.push({
            id: 'carousel',
            label: '图表',
            labelEn:'Figs & Tabs',
            name: 'carousel'
          });
          break;
        }
      }
      if (this.ARTICLE.reflist && this.ARTICLE.reflist.data.length>0){
        this.tabsArray.push({
          id: 'references',
          label: '参考文献',
          labelEn:'References',
          name: 'references'
        });
      }
      if (this.ARTICLE.contribgroup.author && this.ARTICLE.contribgroup.author.length > 0 ||
        this.ARTICLE.contribgroup.editor && this.ARTICLE.contribgroup.editor.length > 0 ||
        this.ARTICLE.contribgroup.translator && this.ARTICLE.contribgroup.translator.length > 0 ||
        this.ARTICLE.contribgroup.reviewer && this.ARTICLE.contribgroup.reviewer.length > 0 ||
        this.ARTICLE.contribgroup.correspondent && this.ARTICLE.contribgroup.correspondent.length > 0 ||
        this.ARTICLE.contribgroup.writer && this.ARTICLE.contribgroup.writer.length > 0
        ){
        this.tabsArray.push({
          id: 'author',
          label: '作者',
          labelEn:'Authors',
          name: 'author'
        });
      }
      if (this.ARTICLE.articlemeta){
        this.tabsArray.push({
          id: 'publish',
          label: '出版信息',
          labelEn:'About',
          name: 'publish'
        });
      }
      //添加自定义tab标签
      if (window.tabListConfig && window.tabListConfig.length > 0){
        this.tabsArray = this.tabsArray.concat(window.tabListConfig);
      }

      var deviceDPI = {}
      var _this = this
      if (window.screen.deviceXDPI != undefined) {
        deviceDPI.x = window.screen.deviceXDPI
        deviceDPI.y = window.screen.deviceYDPI
      } else {
        var tmpNode = document.createElement('DIV')
        tmpNode.style.cssText = 'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden'
        document.body.appendChild(tmpNode)
        if(tmpNode.offsetWidth && tmpNode.offsetWidth!=0){
          deviceDPI.x = parseInt(tmpNode.offsetWidth)
        } else deviceDPI.x = 96
        if (tmpNode.offsetHeight && tmpNode.offsetHeight!=0){
          deviceDPI.y = parseInt(tmpNode.offsetHeight)
        } else deviceDPI.y = 96
        tmpNode.parentNode.removeChild(tmpNode)
      }
      this.GLOBAL.deviceDPI = deviceDPI
      $(window).scroll(() => {
        if ($(window).scrollTop() > 0) {
          _this.upBtnShow = true
        } else {
          _this.upBtnShow = false
        }
      })
      $('#page-foot').css('display','block')
    },
    mounted() {
//      设置主题色
      $('.theme-font').css('color', this.ARTICLE.theme);
      $('a').css('color', this.ARTICLE.theme);
      $('li.active span').css('color', this.ARTICLE.theme);
      $('.theme-background').css('background-color', this.ARTICLE.theme);
      $('.theme-border').css('border-color', this.ARTICLE.theme);
    }
  }
</script>
<style lang="scss" scoped>
  #app{
    width: 100%;
  }

  .jo-up-btn {
    position: fixed;
    right: 10px;
    bottom: 10px;
    width: 35px;
    height: 35px;
    background: url('./assets/img/arrow-top-active.png') no-repeat left top;
    z-index: 100;
  }

  .jo-up-btn:hover {
    background: url('./assets/img/arrow-top-hover.png') no-repeat left top;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue